export default __webpack_public_path__ + "/image/cbu-logo_c0686c3.svg";